import Vue from 'vue';
import VueRouter from 'vue-router';
import ConfigurationsList from '../views/ConfigurationsList.vue';
import SignIn from '../views/SignIn.vue';
import SignUp from '../views/SignUp.vue';
import SignUpSuccess from '../views/SignUpSuccess.vue';
import ContainerSuggestion from '../views/ContainerSuggestion.vue';
import ContainerChoice from '../views/ContainerChoice.vue';
import Configuration from '../views/Configuration.vue';
import Summary from '../views/Summary.vue';
import PasswordReset from '../views/PasswordReset.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import ArrangeBaie from '../views/ArrangeBaie.vue';
import TrunkConfiguration from '../views/TrunkConfiguration.vue';
import TrunkOptions from '../views/TrunkOptions.vue';
import TrunkSummary from '../views/TrunkSummary.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'ConfigurationsList',
    component: ConfigurationsList,
  },
  {
    path: '/connexion',
    name: 'SignIn',
    component: SignIn,
  },
  {
    path: '/inscription',
    name: 'SignUp',
    component: SignUp,
  },
  {
    path: '/inscription-effectuee',
    name: 'SignUpSuccess',
    component: SignUpSuccess,
  },
  {
    path: '/oubli-mot-de-passe',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: PasswordReset,
  },
  {
    path: '/uni-baies',
    name: 'ConfigurationsList',
    component: ConfigurationsList,
  },
  {
    path: '/uni-baies/configuration/:id',
    name: 'Configuration',
    component: Configuration,
  },
  {
    path: '/uni-baies/configuration',
    name: 'Configuration',
    component: Configuration,
  },
  {
    path: '/uni-baies/configuration/:id/suggestion-baie',
    name: 'ContainerSuggestion',
    component: ContainerSuggestion,
  },
  {
    path: '/uni-baies/suggestion-baie',
    name: 'ContainerSuggestion',
    component: ContainerSuggestion,
  },
  {
    path: '/uni-baies/configuration/:id/choix-baie',
    name: 'ContainerChoice',
    component: ContainerChoice,
  },
  {
    path: '/uni-baies/choix-baie',
    name: 'ContainerChoice',
    component: ContainerChoice,
  },
  {
    path: '/uni-baies/configuration/:id/arrangement-baie',
    name: 'ArrangeBaie',
    component: ArrangeBaie,
  },
  {
    path: '/uni-baies/arrangement-baie',
    name: 'ArrangeBaie',
    component: ArrangeBaie,
  },
  {
    path: '/uni-baies/configuration/:id/resume',
    name: 'Summary',
    component: Summary,
  },
  {
    path: '/uni-baies/resume',
    name: 'Summary',
    component: Summary,
  },
  {
    path: '/uni-trunk',
    name: 'TrunkConfiguration',
    component: TrunkConfiguration,
  },
  {
    path: '/uni-trunk/configuration',
    name: 'TrunkConfiguration',
    component: TrunkConfiguration,
  },
  {
    path: '/uni-trunk/options',
    name: 'TrunkOptions',
    component: TrunkOptions,
  },
  {
    path: '/uni-trunk/resume',
    name: 'TrunkSummary',
    component: TrunkSummary,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.afterEach(() => {
  Vue.nextTick(() => {
    document.title = 'Uni | Baies';
  });
});

export default router;
